'use client'

import { useEffect } from 'react'
import { withPostHog } from '@/lib/posthog-client'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // global-error renders when the root layout itself crashes, so the providers tree never
    // mounted and PostHog may not have loaded yet. withPostHog loads and inits it if needed.
    withPostHog((posthog) => posthog.captureException(error))
  }, [error])

  return (
    <html lang="en">
      <body
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '1.5rem',
          textAlign: 'center',
          fontFamily:
            'ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
          background: '#F8F9F7',
          color: '#1A1D1B',
        }}
      >
        <h1 style={{ fontSize: '1.75rem', marginBottom: '0.5rem' }}>
          Something went wrong
        </h1>
        <p style={{ maxWidth: '28rem', opacity: 0.7, marginBottom: '1.5rem' }}>
          We&apos;ve been notified and are looking into it.
        </p>
        <button
          onClick={reset}
          style={{
            padding: '0.5rem 1rem',
            borderRadius: '0.5rem',
            background: '#1A1D1B',
            color: '#F8F9F7',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          Try again
        </button>
      </body>
    </html>
  )
}
